<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="contact-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Accueil des électeurs</p>
        <p class="no-margin dark-gray">Ces informations seront affichées sur la page d'accueil du site de vote.</p>
      </div>
    </div>
  </div>

  <div id="poll-title" class="p-20">
    <p class="dark-blue bold no-margin mb-10">Titre du scrutin <span class="red">*</span></p>
    <div class="mb-20">

      <input type="text" name="poll-title" id="poll-title" class="w-half text-md dark-blue pap-input"
      [(ngModel)]="title" (ngModelChange)="onTitleChange()">

    </div>

    <p class="dark-blue bold">Texte d'accueil / Description <span class="red">*</span></p>

    <textarea name="poll-description" id="poll-description" class="w-full text-md dark-blue pap-input p-10"
      style="height: 120px; resize: none;" maxlength="1000"
      [(ngModel)]="description" (ngModelChange)="onDescriptionChange()"></textarea>
  </div>
</div>